export interface OfferItem {
  name: string
  description: string
  value: number
}

export const offerStack: OfferItem[] = [
  {
    name: 'Protocolo Código Cortisol (7 días)',
    description: 'Los 7 capítulos completos del método de desinflamación biológica.',
    value: 97,
  },
  {
    name: 'Checklist de 7 Días',
    description: 'Tu mapa paso a paso, día por día, para aplicarlo sin pensar.',
    value: 47,
  },
  {
    name: 'Escáner de Inflamación',
    description: 'Diagnóstico guiado para saber cuánto de tu volumen es agua y no grasa.',
    value: 37,
  },
  {
    name: 'Nutrición de Rescate',
    description: 'Lista de Nutrientes de Calma y combinaciones que drenan sodio.',
    value: 39,
  },
  {
    name: 'Movimiento de Seguridad',
    description: 'La rutina que reduce inflamación sin disparar tu cortisol.',
    value: 29,
  },
  {
    name: 'El Interruptor Nocturno',
    description: 'Ritual de Vaciado Mental para dormir profundo desde la primera noche.',
    value: 27,
  },
  {
    name: 'Blindaje Permanente',
    description: 'El sistema para que la inflamación no vuelva después del día 7.',
    value: 21,
  },
]

export const TOTAL_VALUE = 297
export const REGULAR_PRICE = 99
export const TODAY_PRICE = 15.9
export const DISCOUNT_PERCENT = Math.round((1 - TODAY_PRICE / REGULAR_PRICE) * 100)
